module.exports = __webpack_public_path__ + "img/52002757_L.f3fe1b7f.png";